import { Link, useNavigate } from "react-router-dom";
import WrapperFooter from "./Footer.styles";
import CardApp from "../card_app/CardApp";
import { FaFacebookF, FaTiktok } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { useEffect, useState } from "react";
import { clickSocialMidiaFacebook, clickSocialMidiaInstagram, clickSocialMidiaYoutube, clickToDownloadAndroid, clickToDownloadIOS, getMiscDataByType } from "../../hooks/firebase";

const Footer = ({newsletter}) => {
    const redirectTo = link => window.location.href = link
    const [data, setData] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        async function load() {
            const result = await getMiscDataByType()
            setData(result[0])
        }
        load()
    },[])

    function LinkToSocialMidiaFacebook() {
        const handleClick = async (e) => {
            e.preventDefault(); // impede o redirecionamento automático

            try {
            await clickSocialMidiaFacebook(); // espera a função terminar
            window.open("https://www.facebook.com/compreimoveiscom/", "_blank");
            } catch (error) {
            console.error("Erro ao registrar clique:", error);
            }
        };

        return (
            <a onClick={handleClick}>
                <FaFacebookF />
            </a>
        );
    }
    function LinkToSocialMidiaInstagram() {
        const handleClick = async (e) => {
            e.preventDefault(); // impede o redirecionamento automático

            try {
            await clickSocialMidiaInstagram(); // espera a função terminar
            window.open("https://www.instagram.com/compreimoveiscom/", "_blank");
            } catch (error) {
            console.error("Erro ao registrar clique:", error);
            }
        };

        return (
            <a onClick={handleClick}>
                <FaInstagram />
            </a>
        );
    }

    function LinkToSocialMidiaYoutube() {
        const handleClick = async (e) => {
            e.preventDefault(); // impede o redirecionamento automático

            try {
            await clickSocialMidiaYoutube(); // espera a função terminar
            window.open("https://www.youtube.com/@grupocompreimoveis", "_blank");
            } catch (error) {
            console.error("Erro ao registrar clique:", error);
            }
        };

        return (
            <a onClick={handleClick}>
                <FaYoutube />
            </a>
        );
    }

    function LinkToSocialMidiaTikToc() {
        const handleClick = async (e) => {
            e.preventDefault(); // impede o redirecionamento automático

            try {
            await clickSocialMidiaFacebook(); // espera a função terminar
            window.open("https://www.tiktok.com/@compreimoveis.com", "_blank");
            } catch (error) {
            console.error("Erro ao registrar clique:", error);
            }
        };

        return (
            <a onClick={handleClick}>
                <FaTiktok />
            </a>
        );
    }

    function LinkToAppAndroid() {
        const handleClick = async (e) => {
            e.preventDefault(); // impede o redirecionamento automático

            try {
            const response = await clickToDownloadAndroid(); // espera a função terminar
            console.log(response)
            window.open("https://play.google.com/store/apps/details?id=com.auggustus6.compreapp", "_blank");
            } catch (error) {
            console.error("Erro ao registrar clique:", error);
            }
        };

        return <div onClick={handleClick} >
            <CardApp store="Google Play" />
        </div>;
    }

    function LinkToAppIOS() {
        const handleClick = async (e) => {
            e.preventDefault(); // impede o redirecionamento automático

            try {
            const response = await clickToDownloadIOS();
            console.log(response) // espera a função terminar
            window.open("https://apps.apple.com/us/app/compre-im%C3%B3veis/id6737413309", "_blank");
            } catch (error) {
            console.error("Erro ao registrar clique:", error);
            }
        };

        return <div onClick={handleClick}>
            <CardApp store="App Store" />
        </div>
    }


    return <WrapperFooter>
        <div className="top">
            <div className="column actions">
                <span className="title">Clique para</span>
                <span className="button" onClick={() => navigate("/anunciar")}>Anunciar</span>
            </div>
            <div className="column social">
                <span className="title">Baixe nosso app</span>
                <LinkToAppAndroid />
                <LinkToAppIOS />
            </div>
            <div className="column social2">
                <span className="title">Redes Sociais</span>
                <div className="social-midias">
                    <LinkToSocialMidiaFacebook />
                    <LinkToSocialMidiaInstagram />
                    <LinkToSocialMidiaYoutube />
                    <LinkToSocialMidiaTikToc />
                </div>
            </div>
            <div className="column links">
                <span className="title">Links rápidos</span>
                <Link to={"/"}>Início</Link>
                <Link to={"/meus-termos-de-uso"}>Política de uso</Link>
                <Link to={"/publicidade"}>Publicidade</Link>            
            </div>
            <div className="column informative">
                {/* {newsletter === false && 
                    <>
                        <span className="title">Informativos</span>
                        <span className="description">Preencha seu e-mail e receba nossos boletins informativos.</span>
                        <input type="text" placeholder="Melhor email" className="newsletter-input" />
                    </> 
                } */}
                <span className="title">Suporte</span>
                <span className="description">
                    {data !== null && data.email} <br />
                    Whatsapp -  {data !== null && data.whatsapp} 
                </span>
            </div> 
        </div>
        <div className="bottom">
            <span className="location">{data !== null && data.address}</span>
            <span className="copy">Copyright {data !== null && data.copy} compre imóveis. Todos os direitos reservados | CNPJ  {data !== null && data.cnpj} </span>
        </div>
    </WrapperFooter>
}

export default Footer